import { DeductionDocumentUploadResponse, IDeductionDocumentUploadRepository } from "@/core/repositories/deduction";
import { PrivateHttp } from "@/infrastructure/adapters/http";
import { ApiEndpoints } from "@/infrastructure/services/config";
import { ContentType } from "@ir/core/http";

export class DeductionDocumentUploadRepository implements IDeductionDocumentUploadRepository {
    async uploadDocument(file: File): Promise<DeductionDocumentUploadResponse> {
        const formData = new FormData();
        formData.append("file", file);

        return await new PrivateHttp({
            headers: {
                "Content-Type": ContentType.MULTIPART,
            }
        }).post<DeductionDocumentUploadResponse>(ApiEndpoints.UPLOAD_DEDUCTION_DOCUMENT, formData);
    }
}

